<template>
  <p :class="wrapperClass ? wrapperClass : 'margin-bottom-small'">
    <label class="a-checkbox-primary">
      <input
        :checked="shouldBeChecked"
        :class="inputClass"
        :disabled="disabled"
        :name="name"
        type="checkbox"
        :value="value"
        @change="updateCheckbox"
      />
      <span class="a-checkbox-checkmark"></span>
      <span>{{ text }}</span>
    </label>
  </p>
</template>

<script>
export default {
  name: 'AtomCheckboxPrimary',

  props: {
    disabled: Boolean,
    inputStyle: {
      type: String,
      default: ''
    },
    modelValue: Array,
    name: String,
    text: String,
    value: [String, Number],
    wrapperClass: String
  },

  model: {
    prop: 'modelValue',
    event: 'change'
  },

  computed: {
    shouldBeChecked () {
      return this.modelValue.includes(this.value)
    },

    inputClass () {
      switch (this.inputStyle) {
        case 'academy':
        case 'assets':
        case 'billing':
        case 'notifications':
        case 'products':
          return `a-checkbox-input-${this.inputStyle}-primary`
        default:
          return 'a-checkbox-input-primary'
      }
    }
  },

  methods: {
    updateCheckbox (event) {
      let isChecked = event.target.checked
      let newValue = [...this.modelValue]
      if (isChecked) {
        newValue.push(this.value)
      } else {
        newValue.splice(newValue.indexOf(this.value), 1)
      }
      this.$emit('change', newValue)
    }
  }

}
</script>
